import type { DialogContext } from './dialog.types'

import { createContext } from '../utils'

const [DialogProvider, useDialogContext] = createContext<DialogContext>({ isOptional: true })

export { DialogProvider, useDialogContext }
